module.exports = __webpack_public_path__ + "img/words.fca52ced.png";